module.exports = __webpack_public_path__ + "static/bazlunch_testlogga2-2cace5685baba1ce07bf3e7c1cc817a1.png";